export const environment = {
  production: true,

   serverUrl: 'https://api.mazayaoffers.ae/api',//production

  socketUrl: 'https://api.mazayaoffers.ae',
  clientUrl: 'https://api.mazayaoffers.ae',
  useSSO: false,
  instrumentationKey: null,
  defaultLanguage: 'en-US',
  nodeServerUrl:'https://utility.mazayaoffers.ae/utility/1.0',
   nodeServerUrl1:'https://vouchers.mazayaoffers.ae/api/v1',
   benefitUrl:'https://mazayabenefits.mazayaoffers.ae',
  paymentSuccessurl:'https://mazayaoffers.ae/home/payment-success',
  paymentFailureurl:'https://mazayaoffers.ae/home/payment-failure ',
  payfortactlink: 'https://checkout.payfort.com/FortAPI/paymentPage',
  payfortcommand: 'PURCHASE',
  payfortaccesscode: 'dclR1r9SDf4Fe0kdwlUv',
  payfortmerchantidentifier: 'yDVnFjkT',
  shaRequest: "81mgwrg8AUZh/plPBEp1mT$(",


  
  // serverUrl: 'https://mazaya-api.gewaninfotech.com/api', //staging
  // nodeServerUrl:'https://mazaya-utility.gewaninfotech.com/utility/1.0',
  // nodeServerUrl1:'https://mazayabackendapi.gewaninfotech.com/api/v1',
  // benefitUrl:'https://mazaya-benefits.gewaninfotech.com',
  
  // socketUrl: 'https://mazayabackendapi.gewaninfotech.com',
  // clientUrl: 'https://mazaya-api.gewaninfotech.com',
  // useSSO: false,
  // instrumentationKey: null,
  // defaultLanguage: 'en-US',
  // paymentSuccessurl:'https://mazayadev.gewaninfotech.com/home/payment-success',
  // paymentFailureurl:'https://mazayadev.gewaninfotech.com/home/payment-failure',
  // payfortactlink: 'https://sbcheckout.payfort.com/FortAPI/paymentPage',
  // payfortcommand: 'PURCHASE',
  // payfortaccesscode: 'pXOgNQvchAF3hPktmdNN',
  // payfortmerchantidentifier: 'uBtRIcqH',
  // shaRequest: "cnsduifgwegfy",




};

 